/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useState, useEffect } from "react";

// @mui material components
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import Switch from "@mui/material/Switch";
import Tooltip from "@mui/material/Tooltip";
import Divider from "@mui/material/Divider";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import { useKindeAuth } from "@kinde-oss/kinde-auth-react";

// Images
import logoSlack from "assets/images/small-logos/logo-slack.svg";
import logoSpotify from "assets/images/small-logos/logo-spotify.svg";
import logoAtlassian from "assets/images/small-logos/logo-atlassian.svg";
import logoAsana from "assets/images/small-logos/logo-asana.svg";

// Material Dashboard 2 PRO React components
import { useMaterialUIController } from "context";
import { serverBaseURL } from "common/settings";

function Optout() {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const { getToken, getUser } = useKindeAuth();
  const user = getUser();

  const [improve, setImprove] = useState(true);

  //const handleSetImprove = () => setImprove(!improve);
  async function getImproveModel() {
    const accessToken = await getToken();
    const improveModel = await (
      await fetch(`${serverBaseURL}improve_models/${user.id}/`, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      })
    ).json();
    console.log("improve model:", improveModel);
    setImprove(improveModel.improve ?? true);
  }

  async function saveImproveModel() {
    const currentStatus = improve;
    console.log(currentStatus);
    setImprove(!currentStatus);
    const accessToken = await getToken();
    const improveModel = await (
      await fetch(`${serverBaseURL}improve_models/${user.id}/`, {
        method: "PUT",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify({
          improve: !currentStatus,
        }),
      })
    ).json();
    console.log(currentStatus);
    console.log(improveModel);
  }

  useEffect(() => {
    getImproveModel();
  }, []);

  return (
    <Card id="opt-out">
      <MDBox p={3} lineHeight={1}>
        <MDBox mb={1}>
          <MDTypography variant="h5">Opt-out</MDTypography>
        </MDBox>
        <MDTypography variant="button" color="text">
          Here you can setup and manage your integration settings.
        </MDTypography>
      </MDBox>
      <MDBox pt={2} pb={3} px={3}>
        <MDBox
          display="flex"
          justifyContent="space-between"
          alignItems={{ xs: "flex-start", sm: "center" }}
          flexDirection={{ xs: "column", sm: "row" }}
        >
          <MDBox display="flex" alignItems="center">
            <MDBox ml={2} lineHeight={0}>
              <MDTypography variant="h5" fontWeight="medium">
                Improve the model for everyone
              </MDTypography>
              <MDTypography variant="button" color="text">
                Allow your content to be used to train our models, which makes our services better
                for you and everyone who uses it. We take steps to protect your privacy.
              </MDTypography>
            </MDBox>
          </MDBox>
          <MDBox
            display="flex"
            justifyContent="flex-end"
            alignItems="center"
            width={{ xs: "100%", sm: "auto" }}
            mt={{ xs: 1, sm: 0 }}
          >
            <MDBox lineHeight={0} mx={2}>
              <MDTypography variant="button" color="text">
                {improve ? "Enabled" : "Disabled"}
              </MDTypography>
            </MDBox>
            <MDBox mr={1}>
              <Switch checked={improve} onChange={saveImproveModel} />
            </MDBox>
          </MDBox>
        </MDBox>
      </MDBox>
    </Card>
  );
}

export default Optout;
